import { render, staticRenderFns } from "./teachingAndResearch.vue?vue&type=template&id=a6845d88&scoped=true"
import script from "./teachingAndResearch.vue?vue&type=script&lang=js"
export * from "./teachingAndResearch.vue?vue&type=script&lang=js"
import style0 from "./teachingAndResearch.vue?vue&type=style&index=0&id=a6845d88&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6845d88",
  null
  
)

export default component.exports